import baseApi from "@/api/baseApi";

export default {
  create(query) {
    return baseApi.get(`/api-article/slaughter-invoice/create/v1?${query}`);
  },
  preview(query) {
    return baseApi.get(`/api-article/slaughter-invoice/preview/v1?${query}`);
  },
  print(query) {
    return baseApi.get(`/api-article/slaughter-invoice/print/v1?${query}`);
  },
}
